import { calWidgetConstant as cwc } from './constant'
const initialState = {
  groupCalendar: null,
  totalMixrs: 0,
  loading: false,
  error: null
}

export function calWidget(state = initialState, action) {
  switch (action.type) {
    case cwc.GET_MIXRS_BTWN_DAYS_REQUEST: {
      return {
        ...state,
        loading: true
      }
    }
    case cwc.GET_MIXRS_BTWN_DAYS_SUCCESS: {
      let calendars = []
      if (action.response.groupCalendar) {
        const dates = Object.keys(action.response.groupCalendar)
        const mixrObjects = []
        dates.forEach((mixrDate) => {
          mixrObjects.push({
            date: mixrDate,
            events: action.response.groupCalendar[mixrDate].events
          })
        })
        calendars = mixrObjects
      }
      return {
        ...state,
        loading: false,
        groupCalendar: calendars,
        totalMixrs: action.response.stats.total_count
      }
    }
    case cwc.GET_MIXRS_BTWN_DAYS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    case cwc.SET_INITIAL_STATE: {
      return initialState
    }
    default: {
      return state
    }
  }
}
